<template>
  <router-view/>
</template>

<style lang="scss">
* {
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}
body {
    font-feature-settings: "tnum";
    background-color: #fff;
    color: #000000d9;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5715;
    margin: 0;
}
</style>
